const resources = {
    pageTitle: 'Ouvrir une session',
    // SIM-2 / ACS-4126 — credential-entry screen
    credentialLabel: 'Téléphone ou adresse courriel',
    credentialPlaceholder: '(123) 456-7890',
    subtitlePrefix: 'Ouvrez une session ou créez un compte pour profiter de l’',
    subtitleBold: 'expédition standard GRATUITE',
    subtitleSuffix: ' sur toutes les commandes.',
    newToSephora: 'Nouveau client Sephora?',
    continueButton: 'Continuer',
    createAccountButton: 'Créer un compte',
    invalidCredential: 'Entrez une adresse courriel ou un numéro de téléphone valides.',
    // ACS-4362 (VQA, Figma 1308-116056) — client fallback; backend errorMessage takes
    // precedence when present. SDL refines the FR copy on the next merge.
    notFound:
        'Nous n’avons pas trouvé de compte associé à cette adresse courriel ou à ce numéro de téléphone. Vérifiez que les renseignements entrés sont corrects ou créez un compte.',
    // ACS-4362 (VQA, Figma 753-95460 / 1232-1309428) — EN copy per TD-010 until SDL delivers FR.
    reactivateAccount: 'To reactivate the account, please call our Customer Service team at 1-877-SEPHORA (1-877-737-4672).',
    lockedAccountPrefix: 'We have locked your account due to security concerns. Click here to ',
    lockedAccountResetLink: 'Reset your Password',
    lockedAccountSuffix: '.',
    closedAccount: 'Ce compte a été fermé. Communiquez avec le service à la clientèle pour obtenir de l’aide.',
    blockedAccount: 'Votre compte nécessite une attention particulière. Communiquez avec le service à la clientèle pour rétablir l’accès.',
    // ERR_400004 - store-registered user with incomplete registration; backend
    // triggers a verification email (same flow as reset-password).
    storeRegistered:
        'Votre compte doit être vérifié. Nous vous avons envoyé un courriel de vérification. Veuillez vérifier votre boîte de réception pour continuer.',
    genericError: 'Un problème est survenu. Veuillez essayer de nouveau dans quelques instants.',
    // SIM-10 / ACS-4134 — cross-cutting states (EN copy per TD-010 until SDL).
    sessionExpired: 'Votre session a expiré. Veuillez essayer de nouveau.',
    timeoutMessage: 'Cela prend plus de temps que prévu. Veuillez essayer de nouveau.',
    // EN copy per TD-010 until SDL delivers the FR translation.
    loadingLabel: 'Chargement',
    // SIM-7 / ACS-4131 — OTP-first authorization + OTP entry (EN copy per TD-010
    // until SDL delivers FR translations; BR-034: "verification code", never "passcode").
    editLabel: 'Modifier',
    editAriaLabel: 'Modifier l’adresse courriel ou le numéro de téléphone',
    authorizationSubtitle: 'Comment souhaitez-vous recevoir votre code de vérification?',
    smsMethodLabel: 'Recevoir un code de vérification par message texte',
    emailMethodLabel: 'Recevoir un code de vérification par courriel',
    passwordMethodLabel: 'Veuillez saisir le mot de passe',
    smsConsentPrefix:
        'The information collected here will only be used for verification purposes. Message and data rates may apply. By clicking "Send", you (1) agree to the current version of our ',
    smsConsentTextTerms: 'Conditions d’utilisation de la messagerie texte',
    smsConsentMiddle: ' et (2) confirmez avoir lu notre ',
    smsConsentPrivacy: 'Politique de confidentialité',
    smsConsentSuffix: '.',
    sendButton: 'Envoyer',
    otpInputAriaLabel: 'Entrer le code de vérification à 6 chiffres',
    otpInputBoxAriaLabel: 'Saisie du code de vérification {0}',
    otpSectionLabelPhone: 'Vérification du numéro de téléphone',
    otpSectionLabelEmail: 'Vérification de l’adresse courriel',
    otpHeadingPhone: 'Vérifiez vos messages et entrez votre code de vérification',
    otpHeadingEmail: 'Vérifiez votre boîte de réception et entrez votre code de vérification',
    otpSubtitlePrefix: 'Vous recevrez un code à l’adresse ',
    otpSubtitleSuffix: ' si elle est liée à un compte Beauty Insider.',
    resendPrefix: 'Vous n’avez pas reçu ',
    resendChannelPhone: 'le message texte',
    resendChannelEmail: 'le courriel',
    resendQuestion: '? ',
    resendButton: 'Renvoyer le code',
    resendCountdownPrefix: 'Renvoyer le code dans ',
    resendCountdownSuffix: ' secondes',
    tryAnotherMethodButton: 'Essayer une autre méthode',
    otpExpiredOrIncorrect: 'Ce code est expiré ou incorrect. Nous avons envoyé un nouveau code de vérification à ',
    otpSendFailed: 'Nous n’avons pas pu envoyer votre code de vérification. Essayez une autre méthode.',
    otpLimitMessage: 'Tentatives épuisées. Essayez une autre méthode de connexion ou communiquez avec le Service à la clientèle.',
    // SIM-8 / ACS-4132 — password-fallback screen (EN copy per TD-010 until SDL
    // delivers FR translations; BR-034: "verification code", never "passcode").
    passwordLabel: 'Mot de passe',
    signInButton: 'Sign In',
    wrongPasswordError:
        'The password you entered is incorrect. Try again or sign in with a one-time verification code.',
    passwordRequired: 'Veuillez saisir votre mot de passe.',
    forgotPassword: 'Mot de passe oublié?',
    // Terms/Privacy legal copy above the "Sign In" button on the password state.
    signInLegalPrefix: 'By clicking "Sign In", you (1) agree to the current version of our ',
    signInLegalMiddle: ', and (2) have read Sephora\'s ',
    signInLegalSuffix: '.',
    // Password-mode legal anchor label (Figma 283-92324; EN copy per TD-010 until SDL).
    termsOfUse: 'Terms of Use',
    // SIM-9 / ACS-4133 - phone-disambiguation email-confirmation copy (EN per TD-010).
    emailConfirmSubtitle: 'Entrez l’adresse courriel associée à votre compte.',
    emailConfirmLabel: 'Adresse de courriel',
    // SIM-8 / ACS-4132 — forced-challenge step-up alt-channel affordance (Figma
    // 2271-60328; EN copy per TD-010 until SDL delivers FR. BR-034: "verification
    // code", never "passcode").
    noAccessToPhonePrefix: 'No Access to this phone? ',
    sendCodeViaEmail: 'Send verification code via email'
};

// Note: the SMS-consent legal anchor URLs live in the EN locale (SignIn_en_US.js)
// and are imported by AuthorizationScreen from there; they are intentionally NOT
// re-exported here to avoid dead exports.

export default function getResource(label) {
    return resources[label];
}
